// libraries
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {bindActionCreators} from 'redux';

// auth
import SignUp from '../components/user-sign-up';
import {onSubmit, googleSignUp} from '../actions/user-sign-up';

// shared
import {
  VALID_PASSWORD_REGEX,
  INVALID_PASSWORD_ERROR_MESSAGE
} from 'shared/utils';

import {
  setNavigationAnnouncement
} from 'shared/actions/accessibility-announcement';

// redux form validations
const validate = (values) => {
  const errors = {};

  if (!values.identifier) {
    errors.identifier = 'Email is required';
  }

  if (!values.password) {
    errors.password = 'Password is required';
  } else if (!values.password.match(VALID_PASSWORD_REGEX)) {
    errors.password = INVALID_PASSWORD_ERROR_MESSAGE;
  }

  return errors;
};

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    onSubmit,
    googleSignUp,
    setNavigationAnnouncement
  }, dispatch)
);

const form = reduxForm({
  form: 'signup',
  fields: [
    'identifier',
    'password'
  ],
  validate
})(SignUp);

export default connect(
  null,
  mapDispatchToProps
)(form);
